import { httpClient } from "@/services";

export default {
	state: {
		dispatcher: {},
		maps: [],
		setting: {},
		statistics_data: {},
		trailer_type: [],
		trucksOnTheRoadEmails: [],
		departments: [],
	},
	mutations: {
		updateSystem(state, payload) {
			const { dispatcher, maps, setting, statistics_data, trailer_type, trucksOnTheRoad } = payload;
			if (dispatcher) state.dispatcher = dispatcher;
			if (maps) state.maps = maps;
			if (setting) state.setting = setting;
			if (statistics_data) state.statistics_data = statistics_data;
			if (trailer_type) state.trailer_type = trailer_type;
			if (trucksOnTheRoad) state.trucksOnTheRoadEmails = trucksOnTheRoad;
		},
		updateSystemDepartments(state, { departments }) {
			state.departments = departments;
		}
	},
	actions: {
		async getSystem({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/settings/system');

				// const { data } = await httpClient.get('/settings/new-system-settings');
				if (data && !data.error) {
					commit('updateSystem', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getSystemTrucksOnTheRoad({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('/settings/new-system-settings');
				if (data && !data.error) {
					commit('updateSystem', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getSystemDepartments({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get('settings/departments');
				if (data && !data.error) {
					commit('updateSystemDepartments', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async setSystem({ commit, dispatch }, { values, departments, systemOld }) {
			dispatch("actionPreloader", true);
			try {
				const { data: dataSystem } = await httpClient.post('/settings/new-system-settings', values);
				if (dataSystem && !dataSystem.error) {
					commit('updateSystem', dataSystem);
					const { data } = await httpClient.post('/settings/departments', { departments });
					await httpClient.post('/settings/system', systemOld);
					if (dataSystem && !dataSystem.error) {
						commit('updateSystemDepartments', data);
					} else {
						dispatch('setAlert', { type: "error", message: data.error });
					}

					dispatch("actionPreloader", false);
					dispatch('setAlert', { type: "success", message: 'Settings saved successfully.' });
				} else {
					dispatch('setAlert', { type: "error", message: dataSystem.error });
				}
			} catch (e) {
				console.error(e);
			}
		},

		/**
		 * Get Plaid Link token.
		 *
		 * @param {Object} context Vuex context.
		 * @return {Promise<Object>} Plaid Link token response.
		 */
		async getLinkToken({ dispatch }) {
			dispatch("actionPreloader", true);

			try {
				const { data } = await httpClient.post('/link-token');

				console.log(
					'[Plaid] link-token response:',
					data
				);

				return data;
			} catch (error) {
				console.error(
					'[Plaid] getLinkToken error:',
					error
				);

				throw error;
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		/**
		 * Exchange Plaid public token.
		 *
		 * @param {Object} context Vuex context.
		 * @param {Object} payload Request payload.
		 * @return {Promise<Object>} Backend response.
		 */
		async exchangePlaidPublicToken({ dispatch }, payload) {
			dispatch("actionPreloader", true);

			try {
				console.log(
					'[Plaid] exchange payload:',
					payload
				);

				const { data } = await httpClient.post(
					'/exchange-public-token',
					payload
				);

				console.log(
					'[Plaid] exchange response:',
					data
				);

				return data;
			} catch (error) {
				console.error(
					'[Plaid] exchange public token error:',
					error
				);

				throw error;
			} finally {
				dispatch("actionPreloader", false);
			}
		},
	},
	getters: {
		dispatcher: s => s.dispatcher,
		maps: s => s.maps,
		setting: s => s.setting,
		statistics_data: s => s.statistics_data,
		trailer_type: s => s.trailer_type,
		trucksOnTheRoadEmails: s => s.trucksOnTheRoadEmails,
		departments: s => s.departments,
	}
};

